import "./components/jquery";
import "./components/enrollment_form";

import "@story/story_vendor/fancybox3/fancybox";
import "@story/story_assets/dom_extend";
import "@story/story_assets/modules/base";

$.fancybox.defaults.slideShow = false;
$.fancybox.defaults.fullScreen = false;
$.fancybox.defaults.thumbs = false;
$.fancybox.defaults.closeBtn = true;

$(document).ready(function () {
	var $pageHamburger = $(".page-hamburger");
	var $pageHeader = $(".page-header");
	var $pageNav = $(".page-nav");
	var $body = $("body");

	function showMobileMenu() {
		$pageHamburger.addClass("active");
		$pageHeader.addClass("active");
		$pageNav.fadeIn();
		$body.addClass("no-scroll");
	}

	function hideMobileMenu() {
		$pageHamburger.removeClass("active");
		$pageHeader.removeClass("active");
		$pageNav.fadeOut();
		$body.removeClass("no-scroll");
	}

	$(".page-hamburger").click(function () {
		if ($pageHamburger.hasClass("active")) {
			hideMobileMenu();
		} else {
			showMobileMenu();
		}
	});
});
